import axios from "axios";
import {
  fetchProgramsStart,
  fetchProgramsSuccess,
  fetchProgramsFailure,
  addProgramStart,
  addProgramSuccess,
  addProgramFailure,
  updateProgramStart,
  updateProgramSuccess,
  updateProgramFailure,
  deleteProgramStart,
  deleteProgramSuccess,
  deleteProgramFailure,
  fetchProgramNamesStart,
  fetchProgramNamesSuccess,
  fetchProgramNamesFailure
} from "../slicer/programSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

// Helper function to get the auth headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
    
// Fetch programs
export const fetchPrograms = () => async (dispatch) => {
  dispatch(fetchProgramsStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getAllInternationalProgram`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(fetchProgramsSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchProgramsFailure(
        error.response?.data?.message || "Failed to fetch programs"
      )
    );
  }
};

// Add a new program
export const addProgram = (programInfo) => async (dispatch) => {
  dispatch(addProgramStart());
  try {
    const token = getToken();
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/addInternationalProgram`,
      programInfo,
      { headers } // Passed the combined headers object
    );
    dispatch(addProgramSuccess(response.data.data));
  } catch (error) {
    dispatch(
      addProgramFailure(
        error.response?.data?.message || "Failed to add program"
      )
    );
  }
};

// Update a program
export const updateProgram = (programInfo, id) => async (dispatch) => {
  dispatch(updateProgramStart());
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/updateInternationalProgram/${id}`,
      programInfo,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(updateProgramSuccess(response.data.data));
  } catch (error) {
    dispatch(
      updateProgramFailure(
        error.response?.data?.message || "Failed to update program"
      )
    );
  }
};

// Delete a program
export const deleteProgram = (id) => async (dispatch) => {
  dispatch(deleteProgramStart());
  try {
    await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/deleteInternationalProgram/${id}`,
      getAuthHeaders() // Added authentication headers
    );
    dispatch(deleteProgramSuccess(id));
  } catch (error) {
    dispatch(
      deleteProgramFailure(
        error.response?.data?.message || "Failed to delete program"
      )
    );
  }
};


// Note: fetchProgramNames is not defined in the provided snippet,
// but if it were, you would add the getAuthHeaders() to it as well.
// Example for completeness (assuming it fetches data):
export const fetchProgramNames = () => async (dispatch) => {
  dispatch(fetchProgramNamesStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getProgramNames`, // Assuming this endpoint exists
      getAuthHeaders() // Added authentication headers
    );
    dispatch(fetchProgramNamesSuccess(response.data.data));
  } catch (error) {
    dispatch(
      fetchProgramNamesFailure(
        error.response?.data?.message || "Failed to fetch program names"
      )
    );
  }
};